export class RoleConstants {
  public Role = Role;
}

export enum Role {
  BCSUPER = 'BC SUPER',
  BCLSADMIN = 'BC LS ADM',
  BCADMIN = 'BC ADMIN',
  BCACCOUNT = 'BC ACCOUNT',
  BCCUSTOME = 'BC CUSTOME',
  BCINVOICE = 'BC INVOICE',
  BCCERTIFI = 'BC CERTIFI',
  BCORDERS = 'BC ORDERS',
  BCVIEWER = 'BC VIEWER',
  BCLMMGR = 'BC LM MGR',
  BCPPROGR = 'BC PPROGR',
  PORTAL = 'PORTAL',
  BCSUPPORT = 'BC SUPPORT',
  AGREECONT = 'AGREE CONT',
  AGREEMARK = 'AGREE MARK',
  AGREESOFT = 'AGREE SOFT',
  AGREETECH = 'AGREE TECH',
  BREP = 'BREP',
  LSACADEMY = 'LS ACADEMY',
  FINANCIAL = 'FINANCIAL',
  CUSTOMERVISIBLE = 'CUSTOMERVISIBLE',
  EMAILINV = 'EMAIL INV',
  SALES = 'SALES',
}

export interface RequestableRole {
  name: string;
  code: Role;
}

export const REQUESTABLE_PARTNER_ROLES: RequestableRole[] = [
  { name: 'Admin', code: Role.BCADMIN },
  { name: 'Account Information', code: Role.BCACCOUNT },
  { name: 'Customers', code: Role.BCCUSTOME },
  { name: 'Invoices', code: Role.BCINVOICE },
  { name: 'Orders', code: Role.BCORDERS },
];

export const ASSIGNABLE_PARTNER_ROLES: RequestableRole[] = [
  { name: 'LS Retail Portal Access', code: Role.PORTAL },
  { name: 'Jira Access', code: Role.BCSUPPORT },
  { name: 'Business Hub Admin', code: Role.BCADMIN },
  { name: 'Business Hub Account Information', code: Role.BCACCOUNT },
  { name: 'Business Hub Customers', code: Role.BCCUSTOME },
  { name: 'Business Hub Orders', code: Role.BCORDERS },
  { name: 'Business Hub Invoices', code: Role.BCINVOICE },
];

export const ASSIGNABLE_DIR_END_ROLES: RequestableRole[] = [
  { name: 'Jira Access', code: Role.BCSUPPORT },
  { name: 'Business Hub Admin', code: Role.BCADMIN },
  { name: 'Business Hub Account Information', code: Role.BCACCOUNT },
  { name: 'Business Hub Invoices', code: Role.BCINVOICE },
];

export const REQUESTABLE_DIR_END_ROLES: RequestableRole[] = [
  { name: 'Admin', code: Role.BCADMIN },
  { name: 'Account Information', code: Role.BCACCOUNT },
  { name: 'Invoices', code: Role.BCINVOICE },
];
